export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-calender-1.0.0',
    name: 'JDSDatepickerCalendar'
  },
  hierarchy: {
    container: [
      'jds_datepicker_calendar_header',
      {
        'rows-container': ['jds_datepicker_calendar_row']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{d_0}',
      'justify-content': '{d_1}',
      'align-items': '{d_2}',
      gap: '{d_3}'
    },
    'rows-container': {
      'flex-direction': '{d_4}',
      flex: 1
    }
  },
  variant: {},
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      jds_datepicker_calendar_header: {
        days: {
          type: 'JDSDatepickerCalendarHeader.days',
          name: 'days',
          object: {
            letter: 'string'
          }
        }
      },
      'rows-container': {
        'rows.day': {
          type: 'date',
          name: 'day'
        },
        'rows.month': {
          type: 'number',
          name: 'month'
        },
        'rows.year': {
          type: 'number',
          name: 'year'
        },
        'rows.selected': {
          type: 'date',
          name: 'selected'
        },
        'rows.disabled': {
          type: 'object',
          name: 'disabled',
          object: {
            disabledDays: 'list',
            disabledDates: 'list',
            max: 'date',
            min: 'date'
          }
        },
        'rows.loadedYears': {
          type: 'list',
          name: 'loadedYears',
          object: {
            name: 'string',
            selected: 'boolean',
            disabled: 'boolean'
          }
        },
        value: {
          type: 'list',
          name: 'rows',
          object: {
            row: 'JDSDatepickerCalendarRow.row'
          }
        }
      },
      jds_datepicker_calendar_row: {
        row: {
          type: 'list',
          name: 'rows.row',
          object: {
            value: 'string',
            state: 'JDSDatepickerCalendarButton.state'
          }
        }
      }
    },
    events: {
      container: {
        onSwipeLeft: 'onSwipeLeft',
        onSwipeRight: 'onSwipeRight'
      },
      jds_datepicker_calendar_row: {
        onClick: 'onSelect'
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: '_calendarAriaLabel',
            value: 'Select date from calendar'
          }
        }
      },
      jds_datepicker_calendar_row: {
        properties: {
          dateAriaLabel: {
            name: 'dateAriaLabel',
            function: true
          }
        }
      }
    }
  }
};
